var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStepQuiz = function SvgStepQuiz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.753 6.121 1.061 1.061 2.121-2.121.708.707-2.829 2.828-1.768-1.768.707-.707ZM9 7.775h12v-1H9v1ZM9 12.775h12v-1H9v1ZM21 17.775H9v-1h12v1ZM4.814 12.182l-1.06-1.06-.708.707 1.768 1.768 2.829-2.829-.708-.707-2.12 2.121ZM5.05 18.475a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z",
    fill: "currentColor"
  })));
};
export default SvgStepQuiz;